export const successAction = (action: string) => `${action}_SUCCESS`;
export const failAction = (action: string) => `${action}_FAIL`;
